import React from 'react'
import { useState,useEffect } from 'react';
import { motion } from "framer-motion";
import { GoChevronDown, GoChevronUp } from "react-icons/go";

const ServiceCard = ({services}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [showAll, setShowAll] = useState(false);
  
    useEffect((services) => {
      const handleResize = () => setIsMobile(window.innerWidth < 1024);
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const initialCount = isMobile ? 1 : 4;

    const visibleService = showAll ? services : services?.slice(0, initialCount);
  return (
    <>
       {/* کارت ها */}
       <div className="flex flex-col items-center gap-10 justify-between h-max lg:px-10 px-5 w-full bg-blue_light mt-5 lg:py-10 py-6">
       {/* عنوان */}
       <p className="lg:text-[22px] text-[18px] text-special font-bold">
           خدمات اصلی بارسرا
       </p>

       {/* کارت‌ها */}
       <div className="flex lg:flex-row flex-col min-w-full gap-7 justify-start py-5 overflow-x-scrol max-w-full  ">
           {/* ثبت بار */}
           {
            isMobile?
            <div className="w-full  overflow-x-auto relative">
            <motion.div
                className="flex gap-4 snap-mandatory"
                animate={{ x: ["100%", "50%"] }} 
                transition={{ repeat: Infinity, duration: 10, ease: "linear" }}
            >
                {services.concat(services).map((it, idx) => (
                <div key={idx} className="flex-shrink-0 w-[250px] h-max lg:w-1/4 snap-start">
                     <CardService
                  title={it.title}
                 children={it.desc}
                 icon={it.icon}
             
                />
                </div>
                ))}
            </motion.div>
        </div>
            :

               visibleService?.map((it,index)=>(
                <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="w-full lg:w-1/4"
              >
                <CardService
                  title={it.title}
                 children={it.desc}
                 icon={it.icon}
             
                />
              </motion.div>
               )
                )
           }
   
        
       </div>
{/* 

       {isMobile && (
           <button
           onClick={() => setShowAll(!showAll)}
           className="flex items-center gap-2 text-special font-bold hover:text-blue-950 transition-colors"
           >
               <p> {showAll ? "بستن" : "نمایش بیشتر"}</p>
          
          {
           showAll ?
           <GoChevronUp size={20}></GoChevronUp>
           :
           <GoChevronDown size={20}></GoChevronDown>

          }
           
           </button>
       )} */}
   </div>
   </>

  )
}
function CardService({ title, children ,icon}) {
    return (
      <div className="rounded-[20px] hover:scale-105 transition duration-200 text-special 
                      w-full  bg-white h-[300px] lg:h-[400px] 
                      shadow-md flex flex-col justify-between items-center 
                      px-6 lg:px-10 py-6 lg:py-10 border-[1px] border-gray-500">
        {/* آیکون رو اینجا می‌تونی به شرط title بزنی */}
        {icon}
        <p className="text-center my-3 text-[16px] lg:text-xl font-bold whitespace-normal">
          {title}
        </p>
        <div className="w-full mt-2">
          <p className="text-[13px] lg:text-sm text-center font-light whitespace-normal leading-relaxed">
            {children}
          </p>
        </div>
        <button className="mt-4 h-[36px] lg:max-h-[60px] rounded-md w-full border border-special text-center text-[13px] lg:text-md px-3 lg:px-5 py-1 hover:bg-special hover:text-white transition-colors duration-200">
          اطلاعات بیشتر
        </button>
      </div>
    );
  }

export default ServiceCard
